module.exports = __webpack_public_path__ + "assets/img/soft2.9ec896fb.jpg";